import React from 'react';
import PropTypes from 'prop-types';

import GlobalStyle from './GlobalStyle';
import SiteHeaderPartnerPage from './SiteHeaderPartnerPage';
import SiteBottomPartnerPage from './SiteBottomPartnerPage';
import StickyHeaderWrapper from './StickyHeaderWrapper';

const Layout = ({ children, selectedLocale, partnerLogo }) => (
  <>
    <GlobalStyle />

    <StickyHeaderWrapper>
      {() => <SiteHeaderPartnerPage partnerLogo={partnerLogo} />}
    </StickyHeaderWrapper>

    <main style={{ flex: 1 }}>{children}</main>

    <SiteBottomPartnerPage selectedLocale={selectedLocale} />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  partnerLogo: PropTypes.shape({}).isRequired,
};

export default Layout;
